/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Private_Models_Connection_Model_CountInputs */



/**
* | output |
* | --- |
* | "Models: {count}" |
*
* @param {Private_Models_Connection_Model_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_connection_model_count = /** @type {((inputs: Private_Models_Connection_Model_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Connection_Model_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Modelle: ${i?.count}`)
	return /** @type {LocalizedString} */ (`Models: ${i?.count}`)
});